<template>
  <v-container>
    <v-app-bar app>
      <v-app-bar-nav-icon @click.stop="drawer = !drawer"></v-app-bar-nav-icon>
      <v-spacer></v-spacer>
      <div class="d-flex flex-row align-center" v-if="showUserOverlay && this.$store.getters.isAdmin">
        <v-text-field width="250" clearable v-model="employNr" label="Mitarbeiter Nr" variant="solo-filled"/>
        <v-btn @click="changeUser" color="secondary" variant="plain">
          <v-icon>mdi-check-bold</v-icon>
        </v-btn>
      </div>
      
      <v-btn v-if="this.$store.getters.isAdmin" color="secondary" @click="() => {showUserOverlay = !showUserOverlay}">
        <v-icon>mdi-account-edit</v-icon>
      </v-btn>
      <span class="mr-3">{{this.$store.getters.userName}}</span>
      <span class="mx-4">{{this.$store.getters.environment}}</span>
    </v-app-bar>

    <v-navigation-drawer v-model="drawer" color="primary" temporary floating>
      <v-list>
        <v-list-item @click="closeDrawer" v-for="item in userItems" :key="item.value" link :to="{ name: item.value }">
          <v-list-item-title>{{ item.title }}</v-list-item-title>
        </v-list-item>
      </v-list>
      <v-divider></v-divider>
      <v-list v-if="this.$store.getters.isAdmin">
        <v-list-item  @click="closeDrawer" v-for="item in adminItems" :key="item.value" link :to="{ name: item.value }">
          <v-list-item-title>{{ item.title }}</v-list-item-title>
        </v-list-item>
      </v-list>
    </v-navigation-drawer>
  </v-container>
</template>

<script lang="ts">
import {defineComponent, ref} from 'vue';
import { useRouter } from 'vue-router'
import {GetEmployDataByEmpNr, GetEmployVacationData} from "@/data/employData";
import {notifyInfo} from "vuetify3-dialog";
import {GetUserDataByEmail, GetUserDataByAdacount} from "@/data/userData";
import {store} from "@/store";
import {GetShiftSetting} from "@/data/shiftSettings";
import {loadSettings} from "@/rules/ruleEngine";
export default defineComponent({
  data: () => ({
    userItems: [
      {
        title: 'Startseite',
        value: 'home',
      },
      {
        title: 'Wunschdienstplan',
        value: 'wuensche',
      },
      {
        title: 'Urlaubswünsche',
        value: 'urlaubswuensche',
      },
      {
        title: 'Vorlagen',
        value: 'templates',
      },
      {
        title: '8-Wochenplan',
        value: 'planview',
      },
    ],
    adminItems: [
      {
        title: 'Zeiträume',
        value: 'period',
      },
      {
        title: 'Benutzerverwaltung',
        value: 'usermanagement',
      },
      {
        title: 'Statistiken',
        value: 'statistics',
      },
      {
        title: 'Schichten',
        value: 'worksettings',
      },
      {
        title: 'Regel-Texte',
        value: 'ruletexts',
      },
      {
        title: 'Benachrichtigungen',
        value: 'notification',
      }
    ],
  }),
  setup() {
    const drawer = ref(false);

    const router = useRouter()
    const showUserOverlay = ref(false);
    const employNr = ref('');
    const closeDrawer = () => {
      drawer.value = false; // Function to close the drawer
    };

    const changeUser = async () => {
      try {
        const data = await GetEmployDataByEmpNr(employNr.value);
        if (!data) {
          await notifyInfo("Mitarbeiter nicht gefunden!", {
            timeout: 1000,
            timer: true,
            closeOnContentClick: true
          });
        }
        
//        const user = await GetUserDataByEmail(data.adacount);
        const user = await GetUserDataByAdacount(data.adacount);
        if (!user) return;
        
        console.log("Change User", user, data)
        store.commit("SET_USER", user);
        store.commit("SET_EMPLOYDATA", data);

        const employVacationData = await GetEmployVacationData(data.emplno);
        store.commit('SET_VACATIONDATA', []);
        store.commit('PUSH_VACATIONDATA', employVacationData);

        let shiftSettings = data?.shiftSettings || null
        console.log("ShiftSettings", shiftSettings)

        if (shiftSettings === null) {
          shiftSettings = await GetShiftSetting(data?.cycleid || '170');
        }
        console.log("ShiftSettings", shiftSettings)
        store.commit("SET_USERSETTINGS", shiftSettings);

        try {
          await loadSettings(shiftSettings);
          console.log("Mitarbeiter gewechselt", shiftSettings);
          router.push('/')
        } catch (error) {
          console.error('Error loading settings:', error);
        }
      } catch (error) {
        await notifyInfo("Mitarbeiter nicht gefunden!", {
          timeout: 1000,
          timer: true,
          closeOnContentClick: true
        });
        console.error(error);
      }
    };
    
    return { drawer, closeDrawer,showUserOverlay, employNr, changeUser };
  },
});
</script>

<style scoped>
:deep(.v-navigation-drawer__content) {
  position: relative;
  overflow: auto;
  padding: 50px 20px;

  @media screen and (min-width: 768px) {
    padding: 50px 10px !important;
  }

  @media screen and (min-width: 1024px) {
    padding: 50px 20px !important;
  }
}

nav li:hover,
nav li.router-link-active,
nav li.router-link-exact-active {
  background-color: indianred;
  cursor: pointer;
}
</style>